const POSITION_STATUSES = [
  'onboarding',
  'offboarding',
  'training',
  'document',
  'review',
  'survey',
  'offer'
];

export default POSITION_STATUSES;
